export default __webpack_public_path__ + "static/media/01AW1MAY66.bfaab219.jpg";